import React from 'react';
import FeatureUnavailable from '../components/FeatureUnavailable';

/**
 * Freelance Audit System Page
 * 
 * This service is currently in development.
 * Display a "Coming Soon" page until the service is ready.
 */
const FreelanceAudit: React.FC = () => {
  return (
    <FeatureUnavailable
      title="Coming Soon"
      subtitle="Freelance Audit System"
      description="Professional audit and compliance management platform for freelance professionals and small businesses. This system is designed to help freelancers and small businesses manage their finances and operations."
      featureType="service"
      serviceName="Freelance Audit System"
      logoSrc="/mono-freelance-audit.png"
      showBackButton={true}
      backPath="/work"
      showHomeLink={true}
      showContactOption={true}
    />
  );
};

export default FreelanceAudit;
